"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geojsonFromCornerCoordinates = exports.geojsonFromLinearRing = exports.transformBbox = exports.transformRing = exports._transformEnclosingPoleRing = exports._transform = void 0;
var proj4_1 = __importDefault(require("proj4"));
var _validates_1 = require("./_validates");
var utils_1 = require("./utils");
var flatten_1 = require("./flatten");
var calc_1 = require("./calc");
var errors_1 = require("./errors");
var constants_1 = require("./constants");
function _transform(points, srcCrs, dstCrs) {
    if (srcCrs === dstCrs)
        return points;
    return points.map(function (p) {
        var transformed = (0, proj4_1.default)(srcCrs, dstCrs, [p[0], p[1]]);
        return __spreadArray(__spreadArray([], transformed, true), p.slice(2), true);
    });
}
exports._transform = _transform;
function _transformEnclosingPoleRing(linearRing, srcCrs, partition, north) {
    var length = linearRing.length - 1;
    var tempCRS = north
        ? constants_1.CRS_ARCTIC_POLAR_STEROGRAPHIC
        : constants_1.CRS_ANTARCTIC_POLAR_STEROGRAPHIC;
    var endY = north ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
    var poleLat = north ? 90 : -90;
    var polarSterographicLinearRing = _transform(linearRing, srcCrs, tempCRS);
    var crossingLats = [];
    for (var i = 0; i < length; i++) {
        if ((0, utils_1.intersection)(polarSterographicLinearRing[i], polarSterographicLinearRing[i + 1], [0, 0], [0, endY]))
            crossingLats.push({
                from: i,
                to: i + 1,
                lat: (0, calc_1.linearInterpolationY)(polarSterographicLinearRing[i], polarSterographicLinearRing[i + 1], 0),
            });
    }
    //not support linear ring that is not enclosing the pole and straddling the antimeridian many times.
    if (crossingLats.length !== 1)
        throw new errors_1.InvalidLinearRingEnclosingPoleError();
    crossingLats.sort(function (a, b) {
        return a.lat - b.lat;
    });
    var crossingLat = north
        ? crossingLats[0]
        : crossingLats[crossingLats.length - 1];
    var ret = [];
    for (var i = 0; i < length; i++) {
        if (i === crossingLat["from"]) {
            var transformed1 = _transform((0, calc_1.linearInterpolationPoints)(polarSterographicLinearRing[crossingLat["from"]], [0, crossingLat["lat"]], { partition: partition }), tempCRS, constants_1.CRS_EPSG4326);
            ret = ret.concat(transformed1.slice(0, transformed1.length - 1));
            if (transformed1[0][0] >= 0) {
                ret = ret.concat([
                    [180, transformed1[transformed1.length - 1][1]],
                    [180, poleLat],
                    [-180, poleLat],
                    [-180, transformed1[transformed1.length - 1][1]],
                ]);
            }
            else {
                ret = ret.concat([
                    [-180, transformed1[transformed1.length - 1][1]],
                    [-180, poleLat],
                    [180, poleLat],
                    [180, transformed1[transformed1.length - 1][1]],
                ]);
            }
            var transformed2 = _transform((0, calc_1.linearInterpolationPoints)([0, crossingLat["lat"]], polarSterographicLinearRing[crossingLat["to"]], { partition: partition }), tempCRS, constants_1.CRS_EPSG4326);
            ret = ret.concat(transformed2.slice(1, transformed2.length - 1));
        }
        else {
            var transformed = _transform((0, calc_1.linearInterpolationPoints)(polarSterographicLinearRing[i], polarSterographicLinearRing[i + 1], { partition: partition }), tempCRS, constants_1.CRS_EPSG4326);
            ret = ret.concat(transformed.slice(0, transformed.length - 1));
        }
    }
    ret.push(ret[0]);
    return ret;
}
exports._transformEnclosingPoleRing = _transformEnclosingPoleRing;
function transformRing(linearRing, srcCrs, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    /*
      not support linear rings of including both poles.
    */
    (0, _validates_1.validLinearRing)(linearRing);
    srcCrs = (0, utils_1.getCrs)(srcCrs);
    var options = Object.assign({
        partition: 0,
    }, userOptions);
    var length = linearRing.length - 1;
    var northPole = _transform([[0, 90]], constants_1.CRS_EPSG4326, srcCrs)[0]; // approximate 90deg
    var enclosingNorthPole = !(0, utils_1.hasSingularity)([northPole]) && (0, utils_1.within)(northPole, linearRing);
    var southPole = _transform([[0, -90]], constants_1.CRS_EPSG4326, srcCrs)[0]; // approximate -90deg
    var enclosingSouthPole = !(0, utils_1.hasSingularity)([southPole]) && (0, utils_1.within)(southPole, linearRing);
    if (enclosingNorthPole && enclosingSouthPole)
        throw new errors_1.EnclosingBothPolesError();
    if (enclosingNorthPole)
        return _transformEnclosingPoleRing(linearRing, srcCrs, options.partition, true);
    if (enclosingSouthPole)
        return _transformEnclosingPoleRing(linearRing, srcCrs, options.partition, false);
    var interpolatedLinearRing = [];
    for (var i = 0; i < length; i++) {
        var interpolated = (0, calc_1.linearInterpolationPoints)(linearRing[i], linearRing[i + 1], {
            partition: options.partition,
        });
        interpolatedLinearRing = interpolatedLinearRing.concat(interpolated.slice(0, interpolated.length - 1));
    }
    interpolatedLinearRing.push(interpolatedLinearRing[0]);
    if (srcCrs === constants_1.CRS_EPSG4326)
        return interpolatedLinearRing;
    return _transform(interpolatedLinearRing, srcCrs, constants_1.CRS_EPSG4326);
}
exports.transformRing = transformRing;
function transformBbox(srcBbox, srcCrs, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    /*
      input bbox is not allowed warp.
    */
    if (!(srcBbox.length === 4 || srcBbox.length === 6))
        throw new errors_1.InvalidBoundsError();
    var options = Object.assign({
        partition: 9,
        expand: false,
    }, userOptions);
    var hasHeight = srcBbox.length === 6;
    var left = srcBbox[0];
    var bottom = srcBbox[1];
    var right = hasHeight ? srcBbox[3] : srcBbox[2];
    var top = hasHeight ? srcBbox[4] : srcBbox[3];
    if (right < left)
        throw new errors_1.NotAllowedWarpBoundsError();
    var points = transformRing([
        [left, bottom],
        [right, bottom],
        [right, top],
        [left, top],
        [left, bottom],
    ], srcCrs, { partition: options.partition });
    var ys = points.map(function (p) {
        return p[1];
    });
    if ((0, utils_1.isCcw)(points)) {
        var xs = points.map(function (p) {
            return p[0];
        });
        if (srcBbox.length === 6)
            return [
                Math.min.apply(Math, xs),
                Math.min.apply(Math, ys),
                srcBbox[2],
                Math.max.apply(Math, xs),
                Math.max.apply(Math, ys),
                srcBbox[5],
            ];
        return [Math.min.apply(Math, xs), Math.min.apply(Math, ys), Math.max.apply(Math, xs), Math.max.apply(Math, ys)];
    }
    try {
        var boundsRing = (0, flatten_1.cutRingAtAntimeridian)(points);
        var xs1_1 = [];
        boundsRing.within.forEach(function (lenearRing) {
            xs1_1 = xs1_1.concat(lenearRing.map(function (p) {
                return p[0];
            }));
        });
        var xs2_1 = [];
        boundsRing.outside.forEach(function (lenearRing) {
            xs2_1 = xs2_1.concat(lenearRing.map(function (p) {
                return p[0];
            }));
        });
        if (srcBbox.length === 6)
            return [
                Math.min.apply(Math, xs1_1),
                Math.min.apply(Math, ys),
                srcBbox[2],
                options.expand ? Math.max.apply(Math, xs2_1) + 360 : Math.max.apply(Math, xs2_1),
                Math.max.apply(Math, ys),
                srcBbox[5],
            ];
        return [
            Math.min.apply(Math, xs1_1),
            Math.min.apply(Math, ys),
            options.expand ? Math.max.apply(Math, xs2_1) + 360 : Math.max.apply(Math, xs2_1),
            Math.max.apply(Math, ys),
        ];
    }
    catch (_a) {
        throw new errors_1.FalidCuttingAntimeridianError();
    }
}
exports.transformBbox = transformBbox;
function geojsonFromLinearRing(linearRing, srcCrs, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    if (!(0, utils_1.isCcw)(linearRing))
        throw new errors_1.NotAllowedCwLinearRingError();
    var options = Object.assign({
        partition: 9,
        expand: false,
    }, userOptions);
    var points = transformRing(linearRing, srcCrs, {
        partition: options.partition,
    });
    var ys = points.map(function (p) {
        return p[1];
    });
    if ((0, utils_1.isCcw)(points)) {
        var xs = points.map(function (p) {
            return p[0];
        });
        return {
            type: "Feature",
            bbox: [
                Math.min.apply(Math, xs),
                Math.min.apply(Math, ys),
                Math.max.apply(Math, xs),
                Math.max.apply(Math, ys),
            ],
            properties: {},
            geometry: { type: "Polygon", coordinates: [points] },
        };
    }
    if (options.expand) {
        var expanded = (0, flatten_1.expandRingAtAntimeridian)(points);
        var xs = expanded.map(function (p) {
            return p[0];
        });
        return {
            type: "Feature",
            bbox: [
                Math.min.apply(Math, xs),
                Math.min.apply(Math, ys),
                Math.max.apply(Math, xs),
                Math.max.apply(Math, ys),
            ],
            properties: {},
            geometry: { type: "Polygon", coordinates: [expanded] },
        };
    }
    var ring = (0, flatten_1.cutRingAtAntimeridian)(points);
    var xs1 = [];
    ring.within.forEach(function (lenearRing) {
        xs1 = xs1.concat(lenearRing.map(function (p) {
            return p[0];
        }));
    });
    var xs2 = [];
    ring.outside.forEach(function (lenearRing) {
        xs2 = xs2.concat(lenearRing.map(function (p) {
            return p[0];
        }));
    });
    var coordinates = [];
    coordinates.push(ring.within.map(function (r) {
        return r;
    }));
    coordinates.push(ring.outside.map(function (r) {
        return r;
    }));
    return {
        type: "Feature",
        bbox: [
            Math.min.apply(Math, xs1),
            Math.min.apply(Math, ys),
            Math.max.apply(Math, xs2),
            Math.max.apply(Math, ys),
        ],
        properties: {},
        geometry: {
            type: "MultiPolygon",
            coordinates: coordinates,
        },
    };
}
exports.geojsonFromLinearRing = geojsonFromLinearRing;
function geojsonFromCornerCoordinates(upperLeft, lowerLeft, upperRight, lowerRight, srcCrs, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    var options = Object.assign({
        partition: 9,
        expand: false,
    }, userOptions);
    return geojsonFromLinearRing([upperLeft, lowerLeft, lowerRight, upperRight, upperLeft], srcCrs, { partition: options.partition, expand: options.expand });
}
exports.geojsonFromCornerCoordinates = geojsonFromCornerCoordinates;
